import { Box, Container, Grid, Link, Stack, Typography } from '@mui/material';

import useAuth from '../../auth/useAuth';
import { ROLES } from '../../config';

export default function Footer() {
  // El distribuidor solo ve su lista de precios: sin enlaces a la tienda ni a "Mi cuenta".
  const { role } = useAuth();
  const isDistributor = role === ROLES.DISTRIBUIDOR;

  return (
    <Box component="footer" sx={{ bgcolor: 'background.neutral', py: 5, mt: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography variant="h6" color="primary.main" gutterBottom>
              PalaciComputers
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Equipos de computo, Perifericos, <br/> componentes y soporte tecnico.
            </Typography>
          </Grid>
          {!isDistributor && (
            <>
              <Grid size={{ xs: 6, md: 4 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Tienda
                </Typography>
                <Stack spacing={1}>
                  <Link href="/catalogo" underline="hover" color="text.secondary" variant="body2">
                    Catálogo
                  </Link>
                  <Link href="/cotizador" underline="hover" color="text.secondary" variant="body2">
                    Cotizador de PC
                  </Link>
                  <Link href="/servicio-tecnico" underline="hover" color="text.secondary" variant="body2">
                    Servicio técnico
                  </Link>
                </Stack>
              </Grid>
              <Grid size={{ xs: 6, md: 4 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Mi cuenta
                </Typography>
                <Stack spacing={1}>
                  <Link href="/mis-pedidos" underline="hover" color="text.secondary" variant="body2">
                    Mis pedidos
                  </Link>
                  <Link href="/mis-cotizaciones" underline="hover" color="text.secondary" variant="body2">
                    Mis cotizaciones
                  </Link>
                  <Link href="/mis-ordenes-servicio" underline="hover" color="text.secondary" variant="body2">
                    Mis órdenes de servicio
                  </Link>
                </Stack>
              </Grid>
            </>
          )}
        </Grid>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 4 }}>
          © {new Date().getFullYear()} PalaciComputers. Todos los derechos reservados.
        </Typography>
      </Container>
    </Box>
  );
}
